import $ from 'jquery';

// Pour pouvoir sélectionner facilement les éléments DOM de filtrage.
const CHECKBOXES = {
    location: {
        all: {id: 'loc-tout', selector: '#loc-tout'},
        item: {selector: '.loc-item'},
    },
    metier: {
        all: {id: 'metier-tout', selector: '#metier-tout'},
        item: {selector: '.metier-item'},
    },
};
let selectedMetiers = [];

function updateSuggestions() {
    const suggestBlock = $('.offre-list.suggestion');
    const suggestContainer = $('.suggestion-container');
    const results = $('.offer-container .offer-item').not('.hide');
    const quatred = results.map((i, elem) => $(elem).attr('data-quatred')).get();
    const suggestions = $('.offer-container .offer-item').filter((i, element) => {
        const offer = $(element);

        return offer.hasClass('hide') && quatred.includes(offer.attr('data-quatred'));
    }).slice(0, 4).clone().removeClass('hide');

    suggestContainer.empty();

    if (suggestions.length > 0) {
        suggestContainer.append(suggestions);
        suggestBlock.removeClass('hide');
    } else {
        suggestBlock.addClass('hide');
    }
}

function updateJobList() {
    // Null si tout est sélectionné, sinon un tableau des localités sélectionnées.
    const selectedLocations = $(CHECKBOXES['location'].all.selector).prop('checked')
        ? []
        : $(CHECKBOXES['location'].item.selector)
            .filter(':checked').map((i, elem) => elem.id).get();

    let countDisplayed = 0;

    $('.offer-container .offer-item').each((i, item) => {
        const offer = $(item);
        const offerLocation = offer.attr('data-loc');
        const offerMetier = offer.attr('data-metier');

        if (
            (selectedLocations.length === 0 || selectedLocations.includes(offerLocation))
            && (selectedMetiers.length === 0 || selectedMetiers.includes(offerMetier))
        ) {
            offer.removeClass('hide');
            countDisplayed++;
        } else {
            offer.addClass('hide');
        }
    });

    const titleSearch = $('#title-search');
    const titleDefault = $('#title-default');
    if ($('.offer-container .offer-item').filter('.hide').length === 0) {
        titleSearch.addClass('hide');
        titleDefault.removeClass('hide');
    } else {
        let text = '';
        if (countDisplayed === 0) {
            text = 'Aucun résultat ne correspond à votre recherche';
        } else if (countDisplayed === 1) {
            text = '1 résultat correspond à votre recherche';
        } else {
            text = countDisplayed + ' résultats correspondent à votre recherche';
        }

        titleDefault.addClass('hide');
        titleSearch.text(text);
        titleSearch.removeClass('hide');
    }

    if (countDisplayed > 0 && countDisplayed <= 4) {
        updateSuggestions();
    } else {
        $('.offre-list.suggestion').addClass('hide');
        $('.suggestion-container').empty();
    }
}

function updateMetierFilterCount() {
    $('#metier-counter .current').text($('.metier-item').filter(':checked').length)
}

function updateMetierBadges() {
    $(CHECKBOXES['metier'].item.selector).each((i, elem) => {
        const badge = $('.close-it[data-target="'+elem.id+'"]');
        if (elem.checked) {
            badge.parent().removeClass('hide');
        } else {
            badge.parent().addClass('hide');
        }
    });
}

$(document).ready(() => {

    // Clic sur un checkbox de localisation ou de métier
    $('.localisation-checkboxes input, .metier-checkboxes input').change(function(e) {
        const input = e.target;
        // Pour savoir si on filter sur une localisation ou un métier.
        const source = $(input).attr('data-src');

        // Gestion du "tout sélectionner".
        if (input.id === CHECKBOXES[source].all.id) {
            // On met les checkbox localisation dans le même état que la checkbox "tout".
            $(CHECKBOXES[source].item.selector).prop('checked', input.checked);
        }

        // On adapte bien "tout sélectionner" à la situation
        $(CHECKBOXES[source].all.selector).prop(
            'checked',
            $(CHECKBOXES[source].item.selector).not(':checked').length === 0
        );

        updateMetierFilterCount();
        if (source ==='location') {
            updateJobList();
        }
    });

    $('.metier-valider').click(function(e) {
        selectedMetiers = $(CHECKBOXES['metier'].all.selector).prop('checked')
            ? []
            : $(CHECKBOXES['metier'].item.selector)
                .filter(':checked').map((i, elem) => elem.id).get();

        updateMetierBadges();
        updateJobList();
    });

    // Effacer les filtres métiers.
    $('#metier-effacer').click(function() {
        $('input[data-src=metier]').prop('checked', false);
        updateMetierFilterCount()
    });

    // Clic sur un badge métier (fermeture).
    $('.close-it').click(function (e) {
        const slug = $(e.target).attr('data-target');
        $('#' + slug).prop('checked', false);

        // On adapte bien "tout sélectionner" à la situation
        $(CHECKBOXES['metier'].all.selector).prop(
            'checked',
            $(CHECKBOXES['metier'].item.selector).not(':checked').length === 0
        );

        selectedMetiers = selectedMetiers.filter(m => m !== slug)

        updateMetierBadges();
        updateMetierFilterCount();
        updateJobList();
    });

    // Préparation compteur métier.
    $('#metier-counter .total').text($('.metier-item').length);
    updateMetierFilterCount();
})
